import React from 'react';
import { find } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import CheckIcon from '@material-ui/icons/Check';
import { green } from '@material-ui/core/colors';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useAuth } from '@graniot/common/context/AuthContext';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import Badge from '@material-ui/core/Badge';

import comparison from '@graniot/common/components/assets/comparison.gif';
import { useMutateProfileIntro } from '@graniot/common/adapters/profile';


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0
    },
}))(MuiDialogActions);

export default function DialogIntro() {
    const [open, setOpen] = React.useState(true);
    const { t } = useTranslation();

    const { loggedUser, setUserProfile } = useAuth();

    const mutateProfile = useMutateProfileIntro();

    const handleModeStart = () => {
        if (open) {
            mutateProfile.mutate({...loggedUser.profile, show_intro: false, user_seen_functionality: {...loggedUser.profile.user_seen_functionality, comparation: true }});
            setUserProfile({...loggedUser.profile, show_intro: false, user_seen_functionality: {...loggedUser.profile.user_seen_functionality, comparation: true }});
            setOpen(false);
        }
    };

    return (<>
        <Dialog aria-labelledby="customized-dialog-title" open={open}>
            <DialogContent >
                <Typography gutterBottom style={{ color: '#003945', fontWeight: 500, fontSize: 30, textAlign: 'center' }}>
                    {t("satellite-images-every-5-days-and-since-2017-and-much-more")}
                </Typography>
                <Typography gutterBottom >

                </Typography>
                <List component="nav" aria-label="secondary mailbox folders" >

                    <ListItem style={{ textAlign: 'center' }}>
                        <img src={comparison} style={{ width: '100%', borderRadius: 4, marginLeft: 'auto', marginRight: 'auto' }} />
                    </ListItem>
                    <ListItem style={{ textAlign: 'center' }}>
                        <ListItemText primary={<span style={{ color: '#003945' }}><span style={{ fontWeight: 500 }}>{t("visualise-the-vigour-ndvi-surface-humidity-and-chlorophyll-of-your-plot-among-other-indices")}</span></span>} />
                    </ListItem>

                </List>
            </DialogContent>
            <DialogActions style={{ textAlign: 'center' }}>
                <Box display="flex" justifyContent="center" m={1} p={1} bgcolor="background.paper" style={{ width: '100%' }}>
                    <Box p={1} >
                        <Button variant="contained" color="primary" disableElevation size="large" onClick={() => handleModeStart()}>
                            {t("compare-dates")}
                        </Button>
                    </Box>
                </Box>

            </DialogActions>

        </Dialog>

    </>
    );
}